
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import BasePageLayout from '#layouts/BasePageLayout/BasePageLayout';
import DocumentPublished from '#components/common/documentPublished/DocumentPublished';
import {
  GetAnnouncementDocument,
  GetNavigationDocument,
  GetPageDocument,
  useGetPageQuery,
} from '#types/generated/apollo-client';
import logger from '#utils/logger';
import generateUuid from '#utils/uuid';
import initializeClient from '#providers/apollo/initializeClient';
import addApolloState from '#providers/apollo/addApolloState';

type Props = {
  slug: string;
};

const PreviewPage = (props: Props) => {
  const { data } = useGetPageQuery({
    variables: { slug: props.slug },
    initialFetchPolicy: 'cache-only',
  });

  return (
    <BasePageLayout>
      <DocumentPublished
        title={data?.page?.document?.title}
        description={data?.page?.document?.description}
        blocks={data?.page?.document?.blocks || []}
        theme={data?.page?.document?.theme}
      />
    </BasePageLayout>
  );
};

/**
 * @ref https://nextjs.org/docs/basic-features/pages#server-side-rendering
 */
 async function _getServerSideProps(context) {
  const { params } = context;

  let { slug } = params;
  slug = slug.pop();

  try {
    const client = initializeClient({
      context,
    });

    const queries = await Promise.allSettled([
      client.query({
        query: GetPageDocument,
        variables: { slug },
      }),
      client.query({
        query: GetAnnouncementDocument,
      }),
      client.query({
        query: GetNavigationDocument,
        variables: { name: 'Main' },
      }),
      client.query({
        query: GetNavigationDocument,
        variables: { name: 'Footer' },
      }),
      client.query({
        query: GetNavigationDocument,
        variables: { name: 'Profile' },
      }),
    ]);

    const pageResult = queries[0];

    if (pageResult.status !== 'fulfilled' || !pageResult?.value?.data?.page) {
      return {
        notFound: true,
      };
    }

    //add apollo cache to document props
    return addApolloState(client, {
      props: {
        slug,
      },
    });
  } catch (e) {
    const uuid = generateUuid();

    logger.error('Error on rendering page', {
      uuid,
      url: context.resolvedUrl,
      e,
    });
    context.res.statusCode = 500;

    return { props: { error: uuid } };
  }
}

export default PreviewPage;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/[...slug]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  